// Main entry point for bundling all JavaScript files
// This file imports all dependencies in the correct order as defined in the original Gruntfile
// Only includes files that exist in the Build/tnkp-styleguide source

// Modernizr
import './scripts/modernizr-custom.js';

// jQuery version 2.1.4 - import and expose globally
import './vendor/libs/jquery.js';

// General HTML fixes
import './scripts/general-html-fixes.js';

// Libraries from bower_components (webpack resolves these automatically)
import 'filament-sticky/fixedsticky.js';
import 'smooth-scroll/dist/js/smooth-scroll.js';

// CSS Element Queries for responsive panel components
import ElementQueries from 'css-element-queries/src/ElementQueries';
ElementQueries.listen();

// jQuery plugins - these need jQuery to be available first
// Using dynamic import pattern to ensure they load after jQuery is on window
import './vendor/plugins/picker.js';
import './vendor/plugins/picker.date.js';
import './vendor/plugins/picker.time.js';
import './vendor/plugins/flickity.pkgd.js';
import './vendor/plugins/jquery.magnific-popup.js';
import './vendor/plugins/jquery.matchHeight.js';
import './vendor/plugins/shariff.min.js';
import './vendor/plugins/svg4everybody.js';
import './vendor/plugins/awesomplete.js';

// JS files which are created for project use
import './scripts/Remodal-1.0.6/dist/remodal.min.js';
import './scripts/accordion.js';
import './scripts/fixed-sticky.js';
import './scripts/fixed-sticky.timeline.js';
import './scripts/flickity.gallery_bm.js';
import './scripts/flickity.slider.js';
import './scripts/flickity.stage-slider.js';
import './scripts/jquery.neotabs_bm.js';
import './scripts/magnific-popup.js';
import './scripts/nav-flyout.js';
import './scripts/nav-primary.js';
import './scripts/nav-top.js';
import './scripts/off-canvas.nav.js';
import './scripts/pickadate.js';
import './scripts/smoothScroll.js';
import './scripts/svg4evryone.js';
import './scripts/scrollup.js';
import './scripts/table-wrapper.js';
import './scripts/tableToggleViewColumn.js';
import './scripts/tabs.js';
import './scripts/truncate_bm.js';
import './scripts/remodal.js';
import './scripts/googleTagManager_bm.js';
import './scripts/youtube.js';
